import React, { Component } from 'react';
import { connect } from 'react-redux';

//import Loading from "../../components/Loading"
import TemplateDefault from "../Templates/Default";

import API from "../../api";
import { translate } from "../../translate";

import "./style.css";
//import imgBG from "../../../assets/images/bg-full.jpg";

class MeusClientes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            errors: [],
            tableCollunsName: [],
            leads: []
        };

        //API.setImageBackground(imgBG);
    }

    async componentDidMount() {

        Promise.all([
            await this.getMeusCliente(null),
            await this.getMeusCliente("L"),
            await this.getMeusCliente("A"),
            await this.getMeusCliente("T"),
            await this.getMeusCliente("C"),
            await this.getMeusCliente("P")
        ]).then(r => {
                this.setState(state =>{

                    state.leads = r.reduce((accumulator, currentValue) => {
                        return  accumulator.concat(currentValue);
                    }, state.leads)
                    
                    if(state.leads.length === 0) state.errors = [{ type: "alert-danger", msg: "Nenhum resultado foi encontrado..." }];

                    return state;

                })
            })

    }

    getMeusCliente = estagio => {
        return new Promise((resolve, reject) => {

            this.setState({
                errors: [],
                loading: true
            });

            let params = { idusuario: this.props.activeUser.id  }

            if( estagio ) params.estagio = estagio

            API.post("/meusclientes",params ).then(r => {
                let tableNames = [];
                let data = Object.values(r.data);

                if (data[0]) {
                    tableNames = Object.keys(data[0]);
                }

                this.setState({
                    leads: data,
                    tableCollunsName: tableNames,
                    loading: false
                });

                resolve(data)

            }, error => {
                //let errors = [{ type: "alert-danger", msg: "Não foi possivel carregar os dados nesse momento..." }];

                this.setState({
                    //errors: errors,
                    loading: false
                });

                resolve([])
            })


        })
    }



    render() {
        return (
            <TemplateDefault>
                <div id="leads-disponiveis">
                    <h4 style={{ "marginTop": "0" }}>{translate("Meus Clientes")}</h4>
                    <hr />

                    <div className="col-sm-12">
                                    <div className="body-white">
                                        <div className="row area-loading mt-20 mb-20">
                                            <div className="col-sm 12 text-center">
                                                 <span style={{ "fontSize": "20px", "margin": "20px" }}> {translate("Pagina em desenvolvimento...")}</span>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                </div>
            </TemplateDefault >

        )
    }
}

// "state" is set in reducers/index.js
function mapStateToProps(state) {
    return {
        activeUser: state.activeUser
    };
}

export default connect(mapStateToProps)(MeusClientes);